/* eslint-disable no-constant-condition */
import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import API from '@/api/modules/staff';
import QRCode from 'qrcode';
import '@/scss/quill.bubble.css'; //富文本显示样式集合
import { PARAMS } from './config';
import './index.scss';

const StaffQrcode = () => {
  const params: Partial<PARAMS> = useParams();

  //一键生成二维码 是否点击
  const [qrcodeUrl, setQrcodeUrl] = useState<string>('');
  //说明
  const [tips, setTips] = useState<string>('');

  useEffect(() => {
    getQrcode();
    getActive();
  }, []);

  //生成二维码
  const getQrcode = async () => {
    const path = `${window.origin}/good-landing-page/#/customer/${params.activityId}/${params.staffId}`; //员工扫码打开的落地页
    const url = await QRCode.toDataURL(path, {
      quality: 0.8,
      margin: 1,
    });
    setQrcodeUrl(url);
  };

  //获取说明
  const getActive = async () => {
    const res: any = await API.getActivityCommunityById({
      actId: params.activityId || '',
    });
    setTips(res?.rule?.replace(/\n/g, '<br/>'));
  };
  return (
    <div className="staff_qrcode">
      <img
        src={require('@/images/staff/icon_tips.png')}
        alt=""
        className="qrcode_title"
      />
      <div className="qrcode_cont">
        {qrcodeUrl && (
          <img src={qrcodeUrl} alt="" className="qrcode_cont_img" />
        )}
        <img
          src={require('@/images/staff/icon_logo.png')}
          alt=""
          className="qrcode_cont_icon"
        />
      </div>
      <div className="qrcode_tips">
        <img
          src={require('@/images/staff/icon_title.png')}
          alt=""
          className="qrcode_tips_title"
        />
        <div
          className="qrcode_tips_txt"
          dangerouslySetInnerHTML={{ __html: tips }}
        ></div>
      </div>
    </div>
  );
};

export default StaffQrcode;
